/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type TextColorEnum = (typeof TextColorEnum)[keyof typeof TextColorEnum];

export const TextColorEnum = {
  TEXT_COLOR_PRIMARY: 'TEXT_COLOR_PRIMARY',
  TEXT_COLOR_PRIMARY_INVERSE: 'TEXT_COLOR_PRIMARY_INVERSE',
  TEXT_COLOR_SECONDARY: 'TEXT_COLOR_SECONDARY',
  TEXT_COLOR_SECONDARY_INVERSE: 'TEXT_COLOR_SECONDARY_INVERSE',
  TEXT_COLOR_TERTIARY: 'TEXT_COLOR_TERTIARY',
  TEXT_COLOR_TERTIARY_INVERSE: 'TEXT_COLOR_TERTIARY_INVERSE',
  TEXT_COLOR_PLACEHOLDER: 'TEXT_COLOR_PLACEHOLDER',
  TEXT_COLOR_DISABLED: 'TEXT_COLOR_DISABLED',
  TEXT_COLOR_PRICE: 'TEXT_COLOR_PRICE',
  TEXT_COLOR_ERROR: 'TEXT_COLOR_ERROR',
  TEXT_COLOR_CAUTION: 'TEXT_COLOR_CAUTION',
  TEXT_COLOR_SUCCESS: 'TEXT_COLOR_SUCCESS',
} as const;
